import React from 'react'

import isEmpty from 'lodash/isEmpty'

import styles from './ErrorList.module.scss'
import { ErrorIcon } from '../error-icon'
import { Typography } from '../typography/typography'

interface ErrorListProps {
  errors: React.ReactNode[]
  submitFailed?: boolean
  touched?: boolean
  inputId?: string
  dataTestId?: string
}

export const ErrorList: React.FC<ErrorListProps> = ({
  submitFailed = false,
  touched = false,
  errors = [],
  inputId,
  dataTestId,
}) => {
  if (isEmpty(errors) || (!touched && !submitFailed)) {
    return null
  }

  return (
    <ul className={styles.list}>
      {errors.map((error, index) => (
        <li className={styles.listItem} key={`${inputId}-${index}`}>
          <ErrorIcon />
          <Typography
            variant="Montserrat/Medium"
            component="label"
            htmlFor={inputId}
            data-testid={dataTestId}
          >
            {error}
          </Typography>
        </li>
      ))}
    </ul>
  )
}

export default ErrorList
